// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.efZBdLLQfmLBNvI9e2rg {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px;
  gap: 10px;
}

.nIV0nAzSrlXJM23tKnLq {
  width: 45%;
}

.O_qJoXaMTQ3fxInqrR2f {
  margin-top: 1rem;
}

.LbJUAOQkXgAYY3fB482q {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  svg path {
    transition: all 0.3s ease-in-out;
  }
  &.wnOwlTzASgmRFG1JzLMu {
    svg path {
      fill: var(--primary600);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/plugins/wysiwyg/admin/src/components/GlossaryTermsModal/components/StatusRow/StatusRow.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ;IACE,gCAAgC;EAClC;EACA;IACE;MACE,uBAAuB;IACzB;EACF;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 10px;\n  gap: 10px;\n}\n\n.inputWidth {\n  width: 45%;\n}\n\n.linkIconMarginTop {\n  margin-top: 1rem;\n}\n\n.iconWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  svg path {\n    transition: all 0.3s ease-in-out;\n  }\n  &.active {\n    svg path {\n      fill: var(--primary600);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `efZBdLLQfmLBNvI9e2rg`,
	"inputWidth": `nIV0nAzSrlXJM23tKnLq`,
	"linkIconMarginTop": `O_qJoXaMTQ3fxInqrR2f`,
	"iconWrapper": `LbJUAOQkXgAYY3fB482q`,
	"active": `wnOwlTzASgmRFG1JzLMu`
};
export default ___CSS_LOADER_EXPORT___;
